import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

//* NDBX
import { ButtonGroup, ButtonGroupIcon, Section } from "@arp/react-ndbx";

import { SingleQuoteSummary } from "../quoteSummary/SingleQuoteSummary.jsx";
import { CombinedQuoteSummary } from "../quoteSummary/CombinedQuoteSummary.jsx";

//* MUI
import { Card, Typography, Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

//** Hooks */
import useNewBusiness from "../../../hooks/useNewBusiness.ts";

//* Utilities
import { formatCurrency } from "../../../utilities/numericFormat.js";

export default function SuccessfulOutcomesHeader({ ...props }) {
  const { onChange } = { ...props };

  const { data: outcomeData } = useNewBusiness();
  const { covers } = { ...outcomeData };
  const matches = useMediaQuery("(min-width:600px)");

  const {
    showSecond: [showSecond],
  } = useOutletContext();

  //----------------------------------------------------------------
  const [premiumDetails, setPremiumDetails] = useState({
    frequency: "",
    amount: "",
  });

  useEffect(() => {
    setPremiumValues("monthly");
  }, []);

  const handleButtonChange = (e) => {
    setPremiumValues(e);
  };

  const setPremiumValues = (frequency) => {
    const premiumAmount =
      outcomeData?.quoteInformation?.policyPremiumsTotal[frequency];

    const newValue = {
      frequency: frequency,
      amount: formatCurrency(premiumAmount),
    };
    setPremiumDetails(newValue);
    if (onChange) onChange(frequency);
  };
  //----------------------------------------------------------------

  return (
    <>
      {outcomeData ? (
        <Card
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#F1F9FA",
            pt: 4,
            pb: 4,
          }}
        >
          <Section mt={1}>
            <Typography variant="h2-bold">
              {covers?.anyDeclined === true ||
              covers?.anyExclusions === true ||
              covers?.anyLoading === true
                ? "Thank you!"
                : "Great News!"}
            </Typography>
          </Section>
          <Section mt={2} xs={10} md={4}>
            <Typography>
              Note: the selected cover isn't in place until the payment process
              has been completed. Select <b>purchase policy</b> to continue.
            </Typography>
          </Section>
          {/* {data?.numberOfApplicants === 1 ? ( */}
          {1 === 1 ? (
            <SingleQuoteSummary
              firstName={outcomeData?.firstName}
              frequency={premiumDetails.frequency}
              displayName={false}
              isPreQualStage={false}
            />
          ) : (
            <CombinedQuoteSummary frequency={premiumDetails.frequency} />
          )}
          <Section mt={2} sx={{ display: { xs: "none", sm: "initial" } }}>
            <ButtonGroup
              onChange={handleButtonChange}
              name="button-group"
              data="monthly"
              items={[
                { value: "monthly", label: "Monthly" },
                { value: "annual", label: "Yearly" },
              ]}
              sx={{
                direction: "row",
              }}
            />
          </Section>
          <Section mt={2} sx={{ display: { xs: "initial", sm: "none" } }}>
            <ButtonGroupIcon
              onChange={handleButtonChange}
              name="button-group"
              data="monthly"
              items={[
                { value: "monthly", label: "Monthly" },
                { value: "annual", label: "Yearly" },
              ]}
              sx={{
                direction: "row",
              }}
            />
          </Section>
          <Section mt={2}>
            <Typography
              variant="p2"
              display={{ display: "inline-flex", justifyContent: "center" }}
            >
              Quote reference:{" "}
              <Typography ml={1} variant="p2-bold">
                {" "}
                {outcomeData?.quoteInformation?.quoteNumber}
              </Typography>
            </Typography>
          </Section>
          <Section mt={4}>
            <Typography
              variant="p2-bold"
              display={{ display: "inline-flex", justifyContent: "center" }}
            >
              Pay by the month at no extra cost*
            </Typography>
          </Section>
          <Section mt={2} xs={10} sm={8} md={6} xl={3}>
            <Typography variant="p2">
              *Subject to minor adjustments (upwards or downwards) due to
              rounding. Financial institution transaction fees may apply.
            </Typography>
          </Section>
        </Card>
      ) : null}{" "}
    </>
  );
}
